import React from "react";
import vector from "../../assets/Vector29.png";

const AboutSection: React.FC = () => {
  return (
    <footer className="bg-white py-16">
      <div className="flex flex-col justify-center gap-4 mb-2">
        {/* Heading */}
        <h2 className="text-2xl md:text-4xl font-bold text-center text-gray-900 mb-4">
          Who Can Benefit?
        </h2>
        <h2 className="text-xl md:text-3xl font-bold text-center text-gray-900 mb-8">
          Designed for Every Need
        </h2>
        {/* <img className="h-12 w-12" src={vector} alt="Design" /> */}
      </div>

      {/* Tabs */}
      {/* Tabs */}
      <div className="flex flex-wrap justify-center gap-4 mb-8 md:mb-12">
        {["Reports", "Essays", "Proposals", "Templates", "Business Documents"].map(
          (item, index) => (
            <p
              key={index}
              className={`px-6 py-2 text-center rounded-full font-medium ${
                index === 0
                  ? "bg-purple-100 text-purple-800"
                  : index === 1
                  ? "bg-yellow-100 text-yellow-800"
                  : index === 2
                  ? "bg-green-100 text-green-800"
                  : index === 3
                  ? "bg-indigo-100 text-indigo-800"
                  : "bg-blue-100 text-blue-800"
              }`}
            >
              {item}
            </p>
          )
        )}
      </div>

      {/* Description */}
      <p className="text-center  font-normal text-black w-[90%] md:max-w-xl mx-auto mb-12">
        Zynth.ai adapts to students, professionals, and teams—helping you create
        smarter, faster, and more polished documents.
      </p>

      {/* Cards */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 w-[95%] md:w-full">
        <div className="bg-white border border-gray-200 md:border-none md:shadow-md p-6 rounded-xl text-left md:text-center">
          <h3 className="text-2xl md:text-lg font-semibold text-gray-900 mb-4 md:mb-2">
            For Students
          </h3>
          <p className="text-black font-normal">
            Draft essays, reports, and study guides with citations using the AI
            academic and essay writing tool. Easily meet academic standards with
            customizable word counts and formats.
          </p>
        </div>

        <div className="bg-white border border-gray-200 md:border-none md:shadow-md p-6 rounded-xl text-left md:text-center">
          <h3 className="text-2xl md:text-lg font-semibold text-gray-900 mb-4 md:mb-2">
            For Businesses
          </h3>
          <p className="text-black font-normal">
            Generate proposals, compliance docs, and client deliverables with
            the AI proposal generator and business document builder. Save time
            while maintaining professionalism.
          </p>
        </div>

        <div className="bg-white border border-gray-200 md:border-none md:shadow-md p-6 rounded-xl text-left md:text-center">
          <h3 className="text-2xl md:text-lg font-semibold text-gray-900 mb-4 md:mb-2">
            For Teams
          </h3>
          <p className="text-black font-normal">
            From Product and Sales to HR and Leadership — Zynth.ai helps teams
            create structured, professional documents in minutes for marketing,
            project planning, documentation, and employee engagement.
          </p>
        </div>

        {/* Center only on smaller screens, don't let it go full width */}
        <div className="flex justify-center md:col-span-3 lg:col-span-1">
          <div className="bg-white border border-gray-200 md:border-none md:shadow-md p-6 rounded-xl text-left md:text-center w-[90%] max-w-sm">
            <h3 className="text-2xl md:text-lg font-semibold text-gray-900 mb-4 md:mb-2">
              For Researchers
            </h3>
            <p className="text-black font-normal">
              Summarize academic papers, structure arguments, and generate
              data-driven charts with our AI-powered report automation platform
              — ideal for technical writing and academic publishing.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AboutSection;
